import * as React from 'react';

import { Separator } from './components/ui/separator.js';

export function DimeSeparator({ ...props }: Readonly<React.ComponentProps<typeof Separator>>) {
  return <Separator {...props} />;
}
